import { post } from "@/utils/utils";
// 导购相关接口
const storedValueCardCenter = {
  state: {},
  mutations: {
    ADD_PREPAY_CARD() {},
    QUERY_PREPAY_CARD_LIST() {},
    DETAIL_PREPAY_CARD() {},
    EDIT_PREPAY_CARD() {},
    QUERY_PREPAY_CARD_ORDER_LIST() {},
    DETAIL_PREPAY_CARD_ORDER() {},
    DETAIL_PREPAY_CARD_ORDER_BY_CENTERID() {},
    FROZEN_PREPAY_CARD_ORDER() {},
    QUERY_PREPAY_CARD_SALES_LIST() {},
    QUERY_ALL_PREPAY_CARD_SALES_LIST() {},
    VALIDATION_MODLE_GOODS() {},
    INVALID_CART() {},
    QUERY_STORE_PREPAY_CARD_GIVE_INFO() {},
    QUERY_CARD_OPER_RECORD_LIST() {},
    QUERY_PREPAY_CARD_USED_LIST() {},
    CREATE_ACTIVATE_CODE() {},
    QUERY_ACTIVATION_CODE_LIST() {},
    QUERY_DEATIL_ACTIVATION_CODE_LIST() {},
    QUERY_PAGE_LIST() {},
    EDIT_STORE_SETTLE_STATE() {},
    EXCHANGE_GOOD() {},
    EXCHANGEN_GOOD_MSG_PAGE_LIST() {},
    EXCHANGEN_GOOD_DETAIL_EDIT() {},
    EXCHANGEN_GOOD_DETAIL_LIST() {},
    EXCHANGE_OPERATION_RECORD() {},
    CHECK_PREPAY_CARD_AUDIT_STATUS() {}
  },
  actions: {
    check({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/check`,
        name: "CHECK_PREPAY_CARD_AUDIT_STATUS",
        params
      });
    },
    addPrepayCard({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/add`,
        name: "ADD_PREPAY_CARD",
        params
      });
    },
    queryPrepayCardList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/list`,
        name: "QUERY_PREPAY_CARD_LIST",
        params
      });
    },
    detailPrepayCard({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/detail`,
        name: "DETAIL_PREPAY_CARD",
        params
      });
    },
    editPrepayCard({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/edit`,
        name: "EDIT_PREPAY_CARD",
        params
      });
    },
    queryPrepayCardOrderList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/order/list`,
        name: "QUERY_PREPAY_CARD_ORDER_LIST",
        params
      });
    },
    detailPrepayCardOrder({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/order/detail`,
        name: "DETAIL_PREPAY_CARD_ORDER",
        params
      });
    },
    detailPrepayCardOrderByCenterId({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/order/detail`,
        name: "DETAIL_PREPAY_CARD_ORDER_BY_CENTERID",
        params
      });
    },
    frozenPrepayCardOrder({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/frozen`,
        name: "FROZEN_PREPAY_CARD_ORDER",
        params
      });
    },
    queryStorePrepayCardMemberRelList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/queryStorePrepayCardMemberRelList`,
        name: "QUERY_PREPAY_CARD_SALES_LIST",
        params
      });
    },
    queryAllStorePrepayCardMemberRelList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/queryStorePrepayCardMemberRelList`,
        name: "QUERY_ALL_PREPAY_CARD_SALES_LIST",
        params
      });
    },
    validationModleGoods({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/verify`,
        name: "VALIDATION_MODLE_GOODS",
        params
      });
    },
    invalidCart({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/invalidCart`,
        name: "INVALID_CART",
        params
      });
    },
    queryStorePrepayCardMemberRelGiveFromInfo({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/queryStorePrepayCardMemberRelGiveFromInfo`,
        name: "QUERY_STORE_PREPAY_CARD_GIVE_INFO",
        params
      });
    },
    queryCardOperRecordList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/oper_record_list`,
        name: "QUERY_CARD_OPER_RECORD_LIST",
        params
      });
    },
    queryPrepayCardUsedRecordList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/queryPrepayCardUsedRecordList`,
        name: "QUERY_PREPAY_CARD_USED_LIST",
        params
      });
    },
    createCctivatecode({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/create_activate_code`,
        name: "CREATE_ACTIVATE_CODE",
        params
      });
    },
    queryActivationCodeList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/activate_info/list`,
        name: "QUERY_ACTIVATION_CODE_LIST",
        params
      });
    },
    queryDeatilActivationCodeList({ commit }, params) {
      return post({
        commit,
        url: `/back/prepay_card/activate_code/list`,
        name: "QUERY_DEATIL_ACTIVATION_CODE_LIST",
        params
      });
    },
    queryPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeFinanceDayStatInfo/queryPageList`,
        name: "QUERY_PAGE_LIST",
        params
      });
    },
    editStoreSettleState({ commit }, params){
      return post({
        commit,
        url:`/store/storeFinanceDayStatInfo/edit`,
        name:"EDIT_STORE_SETTLE_STATE",
        params
      });
    },
    exchangegood({ commit }, params){
      return post({
        commit,
        url:`/store/storeOrderChangeGoodsInfo/add`,
        name:"EXCHANGE_GOOD",
        params
      });
    },
    exchangenGoodMsgPageList({ commit }, params){
      return post({
        commit,
        url:`/store/storeOrderChangeGoodsInfo/queryPageList`,
        name:"EXCHANGEN_GOOD_MSG_PAGE_LIST",
        params
      });
    },
    exchangenGoodDetailedit({ commit }, params){
      return post({
        commit,
        url:`/store/storeOrderChangeGoodsInfo/edit`,
        name:"EXCHANGEN_GOOD_DETAIL_EDIT",
        params
      });
    },
    exchangenGoodDetaillist({ commit }, params){
      return post({
        commit,
        url:`/store/storeOrderChangeGoodsInfo/detail_list`,
        name:"EXCHANGEN_GOOD_DETAIL_LIST",
        params
      });
    },
    exchangeOperationRecord({ commit }, params){
      return post({
        commit,
        url:`/store/storeOrderChangeGoodsInfo/operate_list`,
        name:"EXCHANGE_OPERATION_RECORD",
        params
      });
    },
  }
};

export default storedValueCardCenter;
